<template lang="pug">
  div.radiogroup(:class="[{'is-qs-hidden': hasCondition && !checkCondition}, {'has-error': hasError}]" ref="radiogroup")
    div.radiogroup__label(v-if='required')
      | {{label + ' '}}
      span.input-field__label-tooltip * <span>Обязательное поле</span>
    div.radiogroup__label(v-else) {{label}}
    div.radiogroup__group.controls-group.controls-group_v-centered
      template(v-for="el in options")
        input-check.radiogroup__group-item(v-bind="{...el}" :name="name" :type="'radio'" :event="'onChange'" :stateChecked="checked.includes(el.id)")
    div.radiogroup__error(v-if="hasError")
      | {{errorMessage}}
</template>

<script>
  // vendor
  // import _find from 'lodash/find';

  // mixins
  import fieldProps from '@/mixins/fieldProps';
  import checkConditions from '@/mixins/questionConditions';

  // components
  import CheckboxRadio from '@/components/UI/CheckboxRadio/CheckboxRadio.vue'
    export default {
      name: 'RadioGroup',
      mixins: [fieldProps, checkConditions],
      components: {
        'input-check': CheckboxRadio
      },
      props: {
        options: {
          type: Array,
          required: true
        },
        selectedOpts: {
          type: Array,
          default: () => ([])
        }
      },
      computed: {
        checked () {
          return this.$props.selectedOpts.map((opt) => {
            return opt.id
          })
        }
      },
      methods: {
        validator () {
          this.hasError = this.data === null && !this.$props.selectedOpts.length && this.$props.required === true;
        },
        changeHandler (data) {
          this.data = data;
          this.validator();
          if (this.hasError) {
            return false;
          }

          const answer = {
            pollId: this.$props.pollId,
            question: this.$props.question,
            value: data.val,
            options: [data]
          };

          this.$store.dispatch('answers/addRemoveAnswer', answer);

          if (this.$props.dependent) {
            this.$props.dependent.map(() => {
              this.$store.dispatch('conditions/changeConditionState', { name: data.name, value: data.value })
            })
          }
        }
      },
      mounted () {
        this.$on('onChange', this.changeHandler);
      },
      data () {
        return {
          hasError: false,
          errorMessage: this.$props.input_type ? this.$props.input_type.error : '',
          data: null
        }
      }
    }
</script>

<style lang="scss" src="./assets/radiogroup.scss"></style>
